import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Binary = createReactComponent("Binary", ["svg", defaultAttributes, [["path", {
  d: "M10 4H6v6h4V4z",
  key: "mdqhcz"
}], ["path", {
  d: "M18 14h-4v6h4v-6z",
  key: "y4gjga"
}], ["path", {
  d: "M14 4h2v6m-2 0h4",
  key: "495vtl"
}], ["path", {
  d: "M6 14h2v6m-2 0h4",
  key: "1eiql5"
}]]]);
export default Binary;